export default {
  'consumables.entity.name': 'Name',
  'consumables.entity.barCode': 'Bar Code',
  'consumables.entity.manufacturer': 'Manufacturer',
  'consumables.entity.sku': 'Internal Code',
  'consumables.entity.manufacturerCode': 'Manufacturer Code',
  'consumables.entity.lifeSpan': 'Life span (days)',
  'consumables.entity.cfop': 'CFOP',
  'consumables.entity.ncm': 'NCM',
  'consumables.entity.unit': 'Unit',
  'consumables.entity.subGroup': 'Group',
  'consumables.entity.comment': 'Comment',
  'consumables.entity.addConsumableImage': 'Add Image',

  'consumables.pageHeader.button.newConsumable': 'New Consumable',
  'consumables.list.header.manufacturingCode': 'Manufacturing Code',
  'consumables.list.header.name': 'Name',
  'consumables.list.header.actions': 'Actions',
  'consumables.list.column.actions.button': 'View/Edit',

  'consumables.create': 'Create New Consumable',
  'consumables.create.notifications.success.title': 'Success',
  'consumables.create.notifications.success.description': 'Consumable created.',

  'consumables.details': 'Consumable Details',

  'consumables.update': 'Update Consumable',
  'consumables.update.notifications.success.title': 'Success',
  'consumables.update.notifications.success.description': 'Consumable updated.',

  'consumables.remove.confirm.title': 'Remove Consumable',
  'consumables.remove.confirm.content':
    'Do you really want to remove the selected consumable?',
  'consumables.remove.success.message': 'Success',
  'consumables.remove.success.description': 'Consumable removed.',

  'consumables.stock': 'Stock',
  'consumables.stock.domain.company': 'Company',
  'consumables.stock.domain.stock': 'Stock',
  'consumables.stock.domain.availableStock': 'Available Stock',
  'consumables.stock.domain.sellPrice': 'Sell Price',
  'consumables.stock.domain.minStock': 'Min Stock',
  'consumables.stock.domain.maxStock': 'Max Stock',
  'consumables.stock.domain.buyPrice': '(US$) Buy Price',
  'consumables.stock.domain.ipi': '(%) IPI',
  'consumables.stock.domain.taxReplacement': '(US$) Tax Replacement',
  'consumables.stock.domain.fixedCost': '(%) Fixed Cost',
  'consumables.stock.domain.icmsExemption': 'ICMS Exemption',
  'consumables.stock.domain.freightCost': '(US$) Freight Cost',
  'consumables.stock.domain.otherExpenses': '(US$) Other Expenses',
  'consumables.stock.domain.realCost': 'Real Cost',
  'consumables.stock.domain.maxDiscount': '% Max Discount',
  'consumables.stock.domain.location': 'Location',
  'consumables.stock.domain.profitMargin': 'Profit Margin',
  'consumables.stock.domain.operationalExpenses': 'Operational Expenses',
  'consumables.stock.domain.enabled': 'Enabled',

  'consumables.lastPurchases.domain.code': 'Purchase Number',
  'consumables.lastPurchases.domain.supplier': 'Supplier',
  'consumables.lastPurchases.domain.releaseDate': 'Purchase Date',
  'consumables.lastPurchases.domain.quantity': 'Quantity',
  'consumables.lastPurchases.domain.unitaryValue': 'Unitary Value',
  'consumables.lastPurchases.domain.totalAmountItem': 'Amount',
  'consumables.lastPurchases.domain.averageCostLastPurchases':
    'Average cost value of the input in the last purchases: ',

  'consumables.stock.enabledCostFields':
    'For the selected company: {company}, the following fields are being used for the "Real Cost"',

  'consumables.stock.update.notifications.success.title': 'Success',
  'consumables.stock.update.notifications.success.description':
    'Company stock updated.',

  'consumables.modal.report.title': 'Generate Report',
  'consumables.modal.report.buttons.viewReport': 'View Report',
  'consumables.modal.report.buttons.pdf': 'Generate PDF',
  'consumables.modal.report.buttons.rtf': 'Generate RTF',
  'consumables.modal.report.buttons.csv': 'Generate CSV',
  'consumables.modal.report.form.description': 'Description, from',
  'consumables.modal.report.form.descriptionUpUntil': 'Up Until',
  'consumables.modal.report.form.group': 'Groups',
  'consumables.modal.report.form.manufactures': 'Manufacturers',
  'consumables.modal.report.form.companies': 'Company',
  'consumables.modal.report.form.localization': 'Localization, From',
  'consumables.modal.report.form.localizationUpUntil': 'Up Until',

  'consumables.status.message.success': 'Input Status successfully changed!',

  'consumables.error.alreadyExists':
    'There is already an Input registered with this internal code or barcode',
  'consumables.error.remove.bonds':
    'The action could not be completed due to a violation of the links for this record!',
};
